const ITEMS = [
  "Risultati garantiti",
  "Corsi a obiettivo, non a ore",
  "Garanzia di Profitto",
  "Classi a numero chiuso",
  "Insegnanti professionisti",
  "166 lezioni teorico-pratiche",
];

export default function EditorialMarquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative overflow-hidden border-y border-[#D8E5E8] bg-[#EFF6F7] py-5" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-display text-lg font-medium tracking-wide text-[#5C7178] sm:text-xl">{item}</span>
            <span className="mx-8 text-[#2997AB]">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
